import { render, staticRenderFns } from "./i-photos.vue?vue&type=template&id=624e9128&scoped=true&"
import script from "./i-photos.vue?vue&type=script&lang=js&"
export * from "./i-photos.vue?vue&type=script&lang=js&"
import style0 from "./i-photos.vue?vue&type=style&index=0&id=624e9128&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624e9128",
  null
  
)

export default component.exports